export function removeTrailingSlash(url: string) {
	// Check if the URL ends with a slash
	if (url.endsWith('/')) {
		// Remove the trailing slash
		return url.slice(0, -1)
	}
	// If URL doesn't end with a slash, return it as is
	return url
}
